import Component from './MyDeals.container';

export default Component;
